import React, {
    useState,
    useEffect,
} from 'react';

import { getCustomer } from "../queries/global";
import config from "../config/config";

import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import UpsellBlock from '../components/upsell-block';
import CustomerMemberhips from './customer-memberships';


const AccountMembership = () => {

    const { data: customer } = getCustomer();

    const [personalisedOffers, setPersonalisedOffers] = useState(null);

    useEffect(() => {
        if (!customer || !customer.tags?.length) {
            setPersonalisedOffers([]);
            return;
        }

        const tagIds = customer.tags.map(tag => tag.id).filter(Boolean);
        const matchingOffers = config.OPTION_FIELDS.account?.personalised_offers?.map((offer) => { if (tagIds.includes(offer.spektrix_tag)) return offer }).filter((notUndefined) => notUndefined !== undefined);
        setPersonalisedOffers(matchingOffers);

    }, [customer]);

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--memberships'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Membership & offers</h1>

                    {customer.subscriptions?.length ?
                        <div className='customer-status-blocks'>
                            <CustomerMemberhips />
                        </div>
                    : config.OPTION_FIELDS.account?.membership_upsell ?
                        <UpsellBlock content={config.OPTION_FIELDS.account.membership_upsell} type="membership-upsell" />
                    : null }

                    {personalisedOffers?.length ?
                        <section className='personalised-offers'>
                            <h2 className='booking-pathway__header'>Your personalised offers</h2>
                            {personalisedOffers.map((offer) =>
                                <div className='personalised-offer' key={offer.spektrix_tag}>
                                    <h3 className='personalised-offer__title'>{offer.name}</h3>
                                    <div className='personalised-offer__introduction' dangerouslySetInnerHTML={{__html: offer.introduction}}></div>
                                    <a href={offer.button?.url} className='personalised-offer__btn btn'>{offer.button?.title ? offer.button.title : 'Find out more'}</a>
                                </div>
                            )}
                        </section>
                    :null}
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={config.OPTION_FIELDS.account?.orders_upsell} type="orders-upsell" />
                </div>

            </div>
        </>
    );
};

export default AccountMembership;
